<template>
  <Popover ref="panelPopover" :showHeader="true" :headerTitle="headerTitle">
    <div class="production-preview-panel-popover" v-if="panel && stageTask">
      <div class="row">
        <div class="col-12 panel-popover-display">
          <div class="font-weight-bold">Stage</div>
          <div>{{stage.name}}</div>
          <div class="font-weight-bold">Status</div>
          <div>{{stageTask.status | formatLookupName(ProductionPanelStageTaskStatusTypeLookup)}}</div>
          <template v-if="stageTask.dueDate">
            <div class="font-weight-bold">Due Date</div>
            <div>{{stageTask.dueDate | formatDateTime}}</div>
          </template>
          <template v-if="stageTask.startedDate && stageTask.status != ProductionPanelStageTaskStatusTypes.pending">
            <div class="font-weight-bold">Production Started</div>
            <div>{{stageTask.startedDate | formatDateTime}}</div>
          </template>
          <template v-if="stageTask.startedProductionStation && stageTask.status != ProductionPanelStageTaskStatusTypes.pending">
            <div class="font-weight-bold">Production Started Station</div>
            <div>{{stageTask.startedProductionStation.name}}</div>
          </template>

          <template v-if="stageTask.completionDate">
            <div class="font-weight-bold">Production Completed</div>
            <div>{{stageTask.completionDate | formatDateTime}}</div>
          </template>
          <template v-if="stageTask.completedProductionStation">
            <div class="font-weight-bold">Production Completed Station</div>
            <div>{{stageTask.completedProductionStation.name}}</div>
          </template>
        </div>
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.production-preview-panel-popover {
  padding: 10px;
  font-size: 0.8rem;
  line-height: 1.1rem;
  min-width: 400px;
}
.panel-popover-display > div {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'
import { ProductionPanelStageTaskStatusTypes, ProductionPanelStageTaskStatusTypeLookup } from '@/store/types'

export default {
  name: 'OrderProductionPanelStageTaskPopover',
  components: {
    Popover
  },
  computed: {
    barcode() {
      if(this.panel)
        return this.panel.barcode
      return ''
    },
    stageTask() {
      if(!this.panel || !this.stage)
        return null
      return this.panel.productionPanelStageTasks.find(task => task.productionStageId == this.stage.id)
    },
    headerTitle() {
      var stageName = this.stage ? this.stage.name : ''
      return `Panel ${this.barcode} - ${stageName}`
    }
  },
  data() {
    return {      
      stage: null,
      panel: null
    }
  },
  created() {
    this.ProductionPanelStageTaskStatusTypes = ProductionPanelStageTaskStatusTypes
    this.ProductionPanelStageTaskStatusTypeLookup = ProductionPanelStageTaskStatusTypeLookup
  },
  methods: {
    displayFromElement(element, panel, stage) {
      this.panel = panel
      this.stage = stage

      this.$refs.panelPopover.displayFromElement(element)
    }
  }
}
</script>